<template>
  <div class="row">
    <div class="col-md-12">
      <finder
        v-if="!selectionConfirmed"
        :tree="productTree"
        :selection="selection"
        frame-classes="col-md-4 col-sd-4 col-xs-4"
        v-on:clickchild="selectProductLocal"
      ></finder>
    </div>
<!--    <div class="col-md-12">-->
<!--      <project-master-data-tab :form="formConverted"-->
<!--                               :formValues="formValues"-->
<!--                               :itemNums="itemNums"-->
<!--                               :hasOrder="readonly"-->
<!--                               :isEditable="!readonly"-->
<!--                               ref="form"-->
<!--                               v-on:input="handleFormInput"-->
<!--                               v-on:valid="(isValid) => $emit(`valid`, isValid)"-->
<!--      ></project-master-data-tab>-->
<!--    </div>-->
  </div>
</template>
<script>
import Finder from '../Elements/Finder.vue';
import ProductPickerMixin from '../Mixins/ProductPicker.js';
import FormsMixin from '../Mixins/Forms.js';
import ProjectMasterDataTab from './ProjectMasterDataTab.vue';

var view = require('../view.js'),
    viewData = {
      images: [],
      frames: [],
      selectionConfirmed: false,
      productSelected: false,
      isSameMaterial: null,
      isSameMaterialValue: true, // Checkbox value (unconfirmed)
      requireAttachments: [],
      itemnums: [],
      properties: [],
      maxunits: 0,
      files: {},
      fileIndex: 0,
      fileQueue: [],
      uploadStatus: 'idle',
      fileCount: 0,
      uploadCount: 0,
      uploadProgress: 0,
      uploadMessage: '',
      uploadError: '',
      loadingPrice: '',
      maxFilesize: 200,
      allowMultiple: true,
      cart: {},
      activeTab: 'selection',
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  mixins: [ ProductPickerMixin, FormsMixin ],
  components: {
    finder: Finder,
    ProjectMasterDataTab,
  },
  props: {
    projectId: {},
    productTree: {},
    formValues: {},
    itemNums: {},
    selection: {},
    readonly: {}
  },
  computed: {
    isSameMaterialConfirmed() {
      return this.isSameMaterial != null;
    },
    materialTitle() {
      var title = this.$t('ProjectDetails.materialSelection');

      if (this.selectionConfirmed) {
        return title + ': ' + this.getMaterialSelection();
      }

      return title;
    },
    btnConfirmProductDisabled() {
      return viewData.selection == null;
    },
    cardTitle() {
      if (this.uploadComplete) {
        if (this.selectionConfirmed)
          return this.$t('Configurator.setProductProps');
        else
          return this.$t('Configurator.selectProduct');
      }

      return this.$t('Configurator.uploadStl');
    },
    hasMultipleFiles() {
      return this.fileCount > 1;
    },
    uploadComplete() {
      return this.fileCount > 0 && this.fileCount == this.uploadCount;
    },
    fileCountTitle() {
      return this.$t('Configurator.fileXofY', {x: this.fileIndex + 1, y: this.fileQueue.length});
    },
    isFileQueueActive() {
      return this.fileQueue.length > 0;
    },
    isFirstFile() {
      return this.fileQueue.length > 0 && this.fileIndex == 0;
    },
    isLastFile() {
      return this.fileQueue.length > 0 && viewData.fileIndex == this.fileQueue.length - 1;
    },
    renderdUrl() {
      return this.$root.url + 'project/' + this.projectId + '/part/';
    },
    // FormsMixin - productFilter()
    // ProductPickerMixin - form()
    formConverted() {
      const f = this.form;
      return Object.keys(f).map(id => Object.assign({}, f[id], {
        id,
      }))
    }
  },
  mounted() {

    this.updateSelection();

    const lastSelection = this.selection.slice().pop();
    const lastObject = this.collectProperties(this.selection, 'children').pop();

    this.productSelected = lastObject[lastSelection].children == null;

    setTimeout(() => {
      this.$emit('valid', this.productSelected);
      this.$emit('form', this.formConverted);
    }, 100);

    if (this.productFilter.length == 0) {
      return;
    }

    // console.log(filter);

    this.getFilteredTree(this.productTree, this.productFilter);
  },
  methods: {
    // ProductPickerMixin - revertSelection()
    // ProductPickerMixin - updateSelection(selection)
    // ProductPickerMixin - collectProperties(selection, property)
    // ProductPickerMixin - getItems(fileCount)
    getBranch() {
      // Retrieves the modelTree as main branch for ProductPickerMixin->collectProperties
      return this.productTree;
    },
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          viewData[i] = resetData[i];
        }
      }
      viewData.selectionConfirmed = !!this.selection.length
      viewData.files = {};
      viewData.fileQueue = [];
      viewData.frames = [ this.productTree ];
      viewData.properties.push(this.productTree.properties);
    },
    getFileList(selection) {
      var files = [];
      Object.keys(this.files).forEach(function(name) {
        // Clone the object
        files.push({
          name: name,
          fileType: 'stl',
          fileHash: this.files[name].fileHash,
          itemnums: this.getItems(),
          imageUrl: this.imageUrl(this.files[name].fileHash),
          missingRequirements: [],
          requireAttachments: JSON.parse(JSON.stringify(this.requireAttachments)),
          formValues: JSON.parse(JSON.stringify(this.formValues)),
          selection: JSON.parse(JSON.stringify(this.selection)),
          images: JSON.parse(JSON.stringify(this.files[name].images))
        });
      }.bind(this));
      return files;
    },
    updatePickingValue(checked) {
      viewData.isSameMaterialValue = checked;
    },
    setPickingMode(isSameMaterial) {
      viewData.isSameMaterial = isSameMaterial == true;
      if (!isSameMaterial) {
        this.startPickingQueue();
      }
    },
    startPickingQueue() {
      viewData.fileQueue = this.getFileList();
      this.pickFile(0, this.isSameMaterial);
    },
    pickFile(index, selectionConfirmed) {
      viewData.fileIndex = index;
      this.load(viewData.fileQueue[index], selectionConfirmed);
    },
    pickNext() {
      var files = this.getFileList();
      this.fileQueue[this.fileIndex] = files.pop();

      // Get the file values from the last frame
      var formValues = JSON.parse(JSON.stringify(this.fileQueue[viewData.fileIndex].formValues));
      if (typeof formValues.units != 'undefined') {
        delete formValues.units;
      }
      this.fileQueue[viewData.fileIndex + 1].formValues = formValues;

      this.pickFile(viewData.fileIndex + 1, this.isSameMaterial);
    },
    pickPrev() {
      this.pickFile(viewData.fileIndex - 1, true);
    },
    pickAndSave() {
      var files = this.getFileList();
      this.fileQueue[this.fileIndex] = files.pop();
      this.save();
    },
    checkForm() {
      for (var key in this.form) {
        if (
          this.form.hasOwnProperty(key)
          && (typeof this.form[key].required != 'undefined')
          && this.form[key].required
          && this.meetsRequirements(this.form[key])
          && (
            (typeof this.formValues[key] == 'undefined')
            || this.formValues[key] == null
            || this.formValues[key] == ''
          )
        ) {
          alert(this.$t('Common.errorFieldMissing', {field: this.$t(this.form[key].label)}));
          return false;
        }
      }

      return true;
    },
    save() {
      if (!this.checkForm()) {
        return;
      }

      this.$emit('save', this.isFileQueueActive ? this.fileQueue : this.getFileList());
    },
    load(file, selectionConfirmed) {
      // console.log('load', file, selectionConfirmed);
      this.fileCount = 1;
      this.uploadCount = 1;
      file.complete = true;
      file.active = true;
      file.progress = 100;
      file.status = 'complete';
      this.files = {};
      this.files[file.name] = file;

      // this.itemnums = file.itemnums;

      this.updateSelection(file.selection);
      this.selectionConfirmed = selectionConfirmed ? file.selection.length > 0 : false;
      this.productSelected = true;
      this.formValues = typeof file.formValues == 'undefined' ? {} : file.formValues;

      this.updatePrices();
    },
    imageUrl(fileHash) {
      return this.renderdUrl + fileHash;
      return this.renderdUrl + 'uploads/' + fileHash;
    },
    imageCount(file) {
      return file.images.length;
    },
    setFileHash(name, hash) {
      viewData.files[name].fileHash = hash;
      return viewData.files[name];
    },
    showStl: function(fileuploader, file) {
      var res = {};
      try {
        res = JSON.parse(file.xhr.response);
      } catch (e) {}

      if ((typeof res == 'object') && (typeof res.result == 'object')) {
        var stlFile = this.setFileHash(file.name, res.result.hash);
        stlFile.active = true;
        // console.log(stlFile);
        // console.log('Chcking ', this.renderdUrl + stlFile.fileHash);

        var checkTimeout = 2000,
            checkMaxTries = 30;

        // Check the processing status every 3 seconds
        var checkStatus = function(count) {
          this.$http.get(this.renderdUrl + stlFile.fileHash).then(function(res) {
            if ((typeof res == 'object') && (typeof res.data == 'object')) {
              if ((typeof res.data.result == 'object') && (typeof res.data.result.hash == 'string')) {
                if (res.data.result.status == 2) {
                  stlFile.complete = true;
                  stlFile.images = res.data.result.meta.images;
                  viewData.uploadStatus = 'Complete';
                  viewData.uploadCount++;
                  return;
                }
              } else if (typeof res.data.error == 'string') {
                viewData.uploadStatus = 'error';
                viewData.uploadError = 'Server Error: ' + res.data.error;
                return;
              }
            }
            if (count < checkMaxTries)
              setTimeout(checkStatus, checkTimeout, count + 1);
          }.bind(this));
        }.bind(this);

        setTimeout(checkStatus, checkTimeout, 1);
      } else {
        viewData.uploadError = this.$t('Common.errorUploadInvalidResp');
      }
    },
    confirmSelection() {
      // When a product is selected and the uploader has multiple files with
      // the option "same material" and no active file queue, start a new file queue
      // with the selected material
      if (this.hasMultipleFiles
          && this.isSameMaterial
          && !this.isFileQueueActive) {

        this.startPickingQueue();
        return;
      }

      viewData.selectionConfirmed = true;
      viewData.formValues = {};
      this.updatePrices();

      this.$emit('valid', true);
    },
    revertSelectionLocal() {
      this.revertSelection();

      this.$emit('valid', false);
    },
    updateUploadProgress(progress, file) {
      viewData.uploadProgress = progress;
      this.addFile(file).progress = progress;
    },
    updateUploadStatus(status, file) {
      viewData.uploadStatus = status;

      if (typeof file == 'object') {
        this.addFile(file).status = status;
      }
    },
    addFile(file) {
      if (typeof viewData.files[file.name] == 'undefined') {
        viewData.fileCount++;
        viewData.files[file.name] = {
          progress: 0,
          status: 'sending',
          fileHash: null,
          images: []
        }
      }
      viewData.files[file.name].file = file;
      return viewData.files[file.name];
    },
    getMaterialSelection(selection) {
      if (typeof selection == 'undefined') {
        selection = this.selection;
      }
      var labels = this.collectProperties(selection, 'label');
      labels.shift();

      let localizedLabels = [];
      labels.forEach((l) => {
        localizedLabels.push(this.$root.getLabelText(l));
      });

      return localizedLabels.join(' › ');
    },
    backToDetails() {
      this.$emit('goback');
    },
    updatePrices() {
      // this.$emit('valid', true);
      this.$forceUpdate();
      return ;

      viewData.loadingPrice = this.$t('Configurator.calcPrice');
      this.$http.post(this.$root.url + 'cart/', {
        items: this.getItems(this.fileCount),
        flat: 1,
        lang: this.$i18n.locale
      }).then(function(res) {
        viewData.loadingPrice = '';
        viewData.cart = res.data.result;
      }.bind(this));
    },
    getItemNums() {
      return {items: this.getItems()};
    },
    refresh() {
      this.$forceUpdate();
    },
    handleFormInput(value, field) {

      // if (this.getFieldItem(field, value)) {
      //   // this.updatePrices();
      //   return;
      // }

      // (this.$refs.form || []).forEach(x => x.refresh());

      // this.formComplete = this.getFormStatus();
      this.$forceUpdate();
      this.isModified = Date.now();
    },
    selectProductLocal(...args) {
      this.selectProduct(...args);

      this.$emit('valid', this.productSelected);
      this.$emit('form', this.formConverted);

      this.$forceUpdate();
    }
  }
});
</script>
